import { render, staticRenderFns } from "./sso_login.vue?vue&type=template&id=4122c72a&scoped=true&"
import script from "./sso_login.vue?vue&type=script&lang=js&"
export * from "./sso_login.vue?vue&type=script&lang=js&"
import style0 from "./sso_login.vue?vue&type=style&index=0&id=4122c72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4122c72a",
  null
  
)

export default component.exports